import { useQuery } from '@tanstack/react-query';
import { Modal, Table, TableColumnsType } from 'antd';
import { HTMLAttributes, useState } from 'react';
import { ApplicantStates } from '../constants/applicant-states';
import jobsService from '../services/jobs.service';
import { IOutsourcingCandidate, Identifiable } from '../types';

interface OutsourcingCandidatesListProps {
	jobId: string;
	onCancel: () => void;
	onOutsourceSubmit: (outsourceRequest: any) => void;
}

export const OutsourcingCandidatesList: React.FC<HTMLAttributes<HTMLDivElement> & OutsourcingCandidatesListProps> = ({
	jobId,
	onCancel,
	onSubmit,
	onOutsourceSubmit,
	...props
}) => {
	const { data: outsourcingCandidatesData, isLoading: outsourcingCandidatesLoading } = useQuery({
		queryKey: ['outsourcingCandidates'],
		queryFn: () =>
			jobsService.getJobApplications(jobId, [
				ApplicantStates.toInterview,
				ApplicantStates.offer,
				ApplicantStates.hired
			]),
		enabled: !!jobId
	});

	const [selectedCandidatesToOutsource, setSelectedCandidatesToOutsource] = useState<string[]>();

	const tableColumns: TableColumnsType<Identifiable<IOutsourcingCandidate>> = [
		{
			title: <span>Code</span>,
			dataIndex: 'code',
			key: 'code'
		},
		{
			title: <span>Title</span>,
			dataIndex: 'title',
			key: 'title'
		}
	];
	return (
		<Modal
			title="Select your candidates"
			open
			onCancel={() => {
				onCancel();
				setSelectedCandidatesToOutsource([]);
			}}
			okText="Confirm"
			okButtonProps={{ disabled: !selectedCandidatesToOutsource?.length }}
			onOk={() => {
				onOutsourceSubmit({ jobId, candidateCodes: selectedCandidatesToOutsource });
				setSelectedCandidatesToOutsource([]);
				onCancel();
			}}
		>
			<Table
				className="ta-table"
				columns={tableColumns}
				dataSource={outsourcingCandidatesData?.map(app => {
					return app.candidate;
				})}
				loading={outsourcingCandidatesLoading}
				rowKey="code"
				rowSelection={{
					type: 'checkbox',
					onChange: selectedRowKeys => {
						setSelectedCandidatesToOutsource(selectedRowKeys as string[]);
					}
				}}
			/>
		</Modal>
	);
};
